import { FONT_FAMILY } from "./font";

// Isolated from the merchant's page: same look as the former checkout iframe
export const style = `
/* The merchant's rules matching the host win over :host, unless :host is !important */
:host {
  padding: 0 !important;
  border: none !important;
  background-color: #fefefe !important;
}

.container {
  /* Resets what is inherited from the merchant's page, except what hides the payment plan */
  all: initial;
  visibility: inherit;
  pointer-events: inherit;
  direction: ltr;
  color: #130a07;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 8px 16px;
  font-family: "${FONT_FAMILY}", sans-serif;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: -0.6px;
}

.fadeIn {
  animation: fadeIn 0.4s ease-out backwards;
}

/* A fast response never shows the skeleton, which would only flash */
.delayed {
  animation-delay: 0.2s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.bold {
  font-weight: 700;
}

.installments {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.installment,
.total {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.total {
  align-items: center;
}

.label {
  font-size: 16px;
  line-height: 135%;
  letter-spacing: normal;
}

.date {
  text-transform: capitalize;
}

.totalAmount {
  text-align: right;
}

.error {
  margin-block: 16px;
}

.fees {
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  opacity: 0.5;
}

.skeleton {
  display: inline-block;
  height: 12px;
  vertical-align: middle;
  border-radius: 6px;
  background-color: currentColor;
  opacity: 0.1;
}

.button {
  font: inherit;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  color: #fff;
  background-color: #130a07;
  border: 3px solid transparent;
  border-radius: 100px;
  box-sizing: border-box;
  height: 50px;
  padding: 0 24px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.fitContent {
  width: -moz-fit-content;
  width: fit-content;
}

.button:hover:not(:disabled) {
  background-color: #3e1509;
}

.button:focus-visible {
  outline: 3px solid #53d9e8;
  outline-offset: -3px;
}

.skeletonButton {
  opacity: 0.1;
  cursor: default;
}

.skeletonButton.fitContent {
  width: 160px;
}

@media (prefers-reduced-motion: reduce) {
  .fadeIn {
    animation: none;
  }
}
`;
